import React from 'react';
import { Award, Clock, DollarSign, Headphones, TrendingUp, Users } from 'lucide-react';

const WhyChooseUs = () => {
  const reasons = [
    {
      icon: Award,
      title: "98% Success Rate",
      description: "Industry-leading approval rate with the USPTO, backed by meticulous preparation and expert legal strategies that maximize your trademark's registration potential."
    },
    {
      icon: Users,
      title: "Dedicated Case Managers",
      description: "Personal case manager assigned to your trademark application, providing direct communication, regular updates, and expert guidance throughout the entire process."
    },
    {
      icon: Clock,
      title: "15+ Years Experience",
      description: "Over a decade of specialized trademark law expertise, successfully navigating thousands of applications across diverse industries and business types."
    },
    {
      icon: DollarSign,
      title: "Transparent Pricing",
      description: "Clear, upfront pricing with no hidden fees. Multiple package options to fit every budget, from basic filing to comprehensive brand protection services."
    },
    {
      icon: TrendingUp,
      title: "Proven Track Record",
      description: "1,000+ trademarks successfully registered for businesses nationwide. Our portfolio spans startups to Fortune 500 companies across all industries."
    },
    {
      icon: Headphones,
      title: "Exceptional Support",
      description: "Responsive customer service with same-day email responses and accessible phone support. We're here to answer your questions every step of the way."
    },
    {
      icon: Award,
      title: "Fast Turnaround",
      description: "Efficient processing with most applications filed within 48 hours. We prioritize speed without compromising the quality and thoroughness of your trademark application."
    },
    {
      icon: Users,
      title: "Nationwide Service",
      description: "Serving clients across all 50 states with comprehensive knowledge of federal trademark law and state-specific requirements for complete brand protection."
    }
  ];

  return (
    <section className="why-choose-section" id="why-choose">
      <div className="section-container">
        <div className="section-header-center">
          <span className="section-label">Why Choose Trademark Texticon</span>
          <h2 className="section-title">
            The Trademark Registration Experts
            <span className="title-highlight"> You Can Trust</span>
          </h2>
          <p className="section-description">
            When it comes to protecting your brand, experience and expertise matter. 
            Discover why thousands of businesses trust us with their trademark registration needs.
          </p>
        </div>

        <div className="why-choose-grid">
          {reasons.map((reason, index) => {
            const Icon = reason.icon;
            return (
              <div key={index} className="why-choose-card">
                <div className="why-choose-icon-wrapper">
                  <div className="why-choose-icon">
                    <Icon size={32} />
                  </div>
                </div>
                <h3 className="why-choose-title">{reason.title}</h3>
                <p className="why-choose-description">{reason.description}</p>
              </div>
            );
          })}
        </div>

        {/* Trust Indicators */}
        <div className="trust-indicators">
          <div className="trust-indicator-item">
            <div className="trust-indicator-icon">🏆</div>
            <div className="trust-indicator-content">
              <div className="trust-indicator-title">USPTO Filing Experts</div>
              <div className="trust-indicator-text">Certified trademark professionals</div>
            </div>
          </div>
          <div className="trust-indicator-item">
            <div className="trust-indicator-icon">⭐</div>
            <div className="trust-indicator-content">
              <div className="trust-indicator-title">Client Satisfaction</div>
              <div className="trust-indicator-text">99% satisfaction rating</div>
            </div>
          </div>
          <div className="trust-indicator-item">
            <div className="trust-indicator-icon">🇺🇸</div>
            <div className="trust-indicator-content">
              <div className="trust-indicator-title">Nationwide Coverage</div>
              <div className="trust-indicator-text">Serving all 50 states</div>
            </div>
          </div>
          <div className="trust-indicator-item">
            <div className="trust-indicator-icon">🔒</div>
            <div className="trust-indicator-content">
              <div className="trust-indicator-title">Secure & Confidential</div>
              <div className="trust-indicator-text">Your information protected</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
